<template>
  <div class="">

    <Head />

    <div class="main reservation">

      <AccesskeyLink target="accesskey_c" accesskey="c" :aria-label="$t('跳到中央內容區塊')">
        {{ $t(':::') }}
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('預約紀錄查詢') }}</li>
          </ol>
        </div>
      </nav>

      <div class="reservation_box">
        <div class="container">

          <div class="title_box">
            <h2>{{ $t('預約紀錄查詢') }}</h2>
          </div>

          <div class="box form_box">

            <div class="group">
              <label for="email" class="form-label">{{ $t('申請人電子信箱') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="email" class="form-control" id="email" :placeholder="$t('請輸入電子信箱')" v-model="queryForm.email">
              <p v-if="errors.email" class="text-danger">{{ errors.email }}</p>
            </div>

            <div class="group">
              <label for="idCard" class="form-label">{{ $t('申請人身分證字號') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="idCard" :placeholder="$t('請輸入身分證字號')"
                v-model="queryForm.idCard">
              <p v-if="errors.idCard" class="text-danger">{{ errors.idCard }}</p>
            </div>

            <div class="btn_box">
              <button class="send_btn" @click="handleSearch" :disabled="isSearching">
                {{ isSearching ? $t('查詢中...') : $t('送出查詢') }}
              </button>
            </div>

          </div>

          <!-- 查詢結果 -->
          <div class="results-container" v-if="showResults">
            <div class="title_box">
              <h3>{{ $t('查詢結果') }}（{{ $t('共') }} {{ records.length }} {{ $t('筆') }}）</h3>
            </div>

            <div v-if="records.length === 0" class="no-records">
              <p>{{ $t('查無符合的預約記錄') }}</p>
            </div>

            <div v-else>
              <div class="record-card" v-for="record in records" :key="record.cgrId">
                <div class="record-header">
                  <h4>{{ $t('報名編號') }}：{{ record.cgrId }}</h4>
                  <p>{{ $t('報名時間') }}：{{ formatDateTime(record.createTime) }}</p>
                </div>

                <div class="record-info">
                  <div class="info-item">
                    <span class="info-label">{{ $t('預約日期') }}</span>
                    <span class="info-value">{{ formatDate(record.regDate) }}</span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">{{ $t('預約時段') }}</span>
                    <span class="info-value">{{ record.timeSlot }}</span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">{{ $t('報名類型') }}</span>
                    <span class="info-value">{{ record.regType }}</span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">{{ $t('審核狀態') }}</span>
                    <span class="info-value" :class="getStatusClass(record.status)">
                      {{ getStatusText(record.status) }}
                    </span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">{{ $t('申請單位') }}</span>
                    <span class="info-value">{{ record.organizationName }}</span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">{{ $t('單位類型') }}</span>
                    <span class="info-value">
                      {{ record.organizationType }}
                      <span v-if="record.organizationTypeOther">({{ record.organizationTypeOther }})</span>
                    </span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">{{ $t('年齡層') }}</span>
                    <span class="info-value">{{ record.ageGroup }}</span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">{{ $t('參觀人數') }}</span>
                    <span class="info-value">
                      {{ record.regType === '無限制人數' ? $t('無限制') : `${record.visitorCount} ${$t('人')}` }}
                    </span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">{{ $t('團體代表姓名') }}</span>
                    <span class="info-value">{{ record.representativeName }}</span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">{{ $t('團體代表手機') }}</span>
                    <span class="info-value">{{ record.representativePhone }}</span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">{{ $t('申請人姓名') }}</span>
                    <span class="info-value">{{ record.applicantName }}</span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">{{ $t('申請人手機') }}</span>
                    <span class="info-value">{{ record.applicantPhone }}</span>
                  </div>

                  <div class="info-item">
                    <span class="info-label">{{ $t('申請人信箱') }}</span>
                    <span class="info-value">{{ record.applicantEmail }}</span>
                  </div>
                </div>

                <div v-if="record.remarks" class="info-item" style="margin-top: 15px;">
                  <span class="info-label">{{ $t('備註') }}</span>
                  <span class="info-value">{{ record.remarks }}</span>
                </div>

                <!-- 審核結果 -->
                <div v-if="record.status !== 0" class="review-section">
                  <div class="info-item">
                    <span class="info-label">{{ $t('審核時間') }}</span>
                    <span class="info-value">{{ formatDateTime(record.reviewTime) }}</span>
                  </div>
                  <div v-if="record.reviewContent" class="info-item" style="margin-top: 10px;">
                    <span class="info-label">{{ $t('審核說明') }}</span>
                    <span class="info-value">{{ record.reviewContent }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';

import AccesskeyLink from '@/views/AccesskeyLink.vue'


export default {
  name: 'ReservationSearch',
  components: {
    Head,
    Footer,

    AccesskeyLink,
  },

  data() {
    return {
      // 查詢表單
      queryForm: {
        email: '',
        idCard: '',
      },

      // 查詢結果
      records: [],
      showResults: false,

      // 查詢中狀態
      isSearching: false,

      // 錯誤訊息
      errors: {},
    };
  },

  methods: {

    // 表單驗證
    validateForm() {
      this.errors = {}

      if (!this.queryForm.email) {
        this.errors.email = this.$t('請輸入申請人電子信箱')
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.queryForm.email)) {
        this.errors.email = this.$t('請輸入有效的電子信箱')
      }

      if (!this.queryForm.idCard) {
        this.errors.idCard = this.$t('請輸入申請人身分證字號')
      }

      return Object.keys(this.errors).length === 0
    },

    // 查詢預約記錄
    async handleSearch() {
      if (!this.validateForm()) {
        return
      }

      if (this.isSearching) return
      this.isSearching = true
      this.showResults = false
      this.records = []

      try {
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaGroupReg/Public/QueryByEmail`
        
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            Email: this.queryForm.email,
            IdCard: this.queryForm.idCard,
          }),
        })

        const data = await response.json()

        if (data.ok) {
          this.records = data.records
          this.showResults = true
        } else {
          alert(data.message || this.$t('查無符合的預約記錄'))
        }
      } catch (error) {
        console.error('查詢失敗:', error)
        alert(this.$t('查詢時發生錯誤，請稍後再試'))
      } finally {
        this.isSearching = false
      }
    },

    // 格式化日期
    formatDate(dateStr) {
      try {
        const date = new Date(dateStr)
        return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`
      } catch {
        return dateStr
      }
    },

    // 格式化日期時間
    formatDateTime(dateStr) {
      if (!dateStr) return '-'
      try {
        const date = new Date(dateStr)
        return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
      } catch {
        return dateStr
      }
    },

    // 取得狀態文字
    getStatusText(status) {
      switch (status) {
        case 0: return this.$t('待審核')
        case 1: return this.$t('已通過')
        case 2: return this.$t('未通過')
        default: return this.$t('未知')
      }
    },

    // 取得狀態樣式
    getStatusClass(status) {
      switch (status) {
        case 0: return 'status-pending'
        case 1: return 'status-approved'
        case 2: return 'status-rejected'
        default: return ''
      }
    },

    //　換頁
    gotoPage(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
  },

}

</script>

<style scoped>
.results-container {
  margin-top: 30px;
}

.record-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #fff;
}

.record-header {
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.record-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
  margin-bottom: 15px;
}

.info-item {
  display: flex;
  flex-direction: column;
}

.info-label {
  font-weight: bold;
  color: #666;
  font-size: 14px;
  margin-bottom: 5px;
}

.info-value {
  font-size: 16px;
  color: #333;
}

.status-pending {
  color: #ff9800;
  font-weight: bold;
}

.status-approved {
  color: #4caf50;
  font-weight: bold;
}

.status-rejected {
  color: #f44336;
  font-weight: bold;
}

.review-section {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  margin-top: 15px;
}

.no-records {
  text-align: center;
  padding: 40px;
  color: #999;
}
</style>
